// Icons.js
import {
  ClipboardList,
  FlaskConical,
  Package,
  ScrollText,
  ShieldCheck,
  Database,
  LayoutDashboard,
  FileText,
  Grid,
  PlayCircle,
  FileBarChart,
  Shield,
  FolderCog,
  BookOpen,
  CheckCircle,
  Settings,
  Paintbrush,
  Ticket,
  Archive,
  LayoutGrid,
  Check,
  Repeat,
  Rocket,
  Sparkles,
  Undo2,
  Square,
  File,
  User,
  Users,
  Clock,
  PencilLine,
  Lock,
  GitBranch,
  GitFork,
  Cog,
  Layers,
  Factory,
  SlidersHorizontal,
  Radar,
  Puzzle,
  CheckSquare,
  X,
  XCircle,
  Workflow,
  HelpCircle,
  Plus,
  QrCode,
  Trash,
  Trash2,
  StopCircle,
  Globe,
  PlaySquare,
  CheckCheck,
  CircleCheck,
  ClipboardCheck,
  Box,
  Eye,
  DiamondPlus,
  Calculator,
  ArrowLeft,
  ListChecks,
  Pencil,
  Network,
  Blocks,
  Activity,
  Calendar,
  CalendarDays,
  UserCheck,
  UserCog,
  Download,
  MapPin,
  Building2,
  Droplet,
  History,
  FileEdit,
  Circle,
  Link,
  BarChart3,
  Cpu,
  Server,
  Scale,
  Timer,
  Hash,
  Briefcase,
  KeyRound,
  Mail,
  Phone,
} from 'lucide-react';

const Icons = {
  ClipboardList,
  FlaskConical,
  X,
  Blocks,
  MapPin,
  Package,
  ClipboardCheck,
  Calendar,
  UserCheck,
  Trash2,
  Activity,
  QrCode,
  Calculator,
  GitBranch,
  BookOpen,
  Trash,
  ScrollText,
  CircleCheck,
  Box,
  ShieldCheck,
  Database,
  Eye,
  LayoutDashboard,
  LayoutGrid,
  FileText,
  Check,
  CheckCircle,
  Undo2,
  ArrowLeft,
  Grid,
  PlayCircle,
  StopCircle,
  FileBarChart,
  Shield,
  FolderCog,
  Plus,
  Settings,
  Paintbrush,
  Ticket,
  Archive,
  Repeat,
  Rocket,
  Sparkles,
  Square,
  File,
  User,
  Users,
  Clock,
  PencilLine,
  Lock,
  Cog,
  Layers,
  Factory,
  SlidersHorizontal,
  Radar,
  Pencil,
  Puzzle,
  CheckSquare,
  Workflow,
  HelpCircle,
  Globe,
  PlaySquare,
  CheckCheck,
  DiamondPlus,
  ListChecks,
  Network,
  CalendarDays,
  UserCog,
  Download,
  Building2,
  Droplet,
  History,
  FileEdit,
  Circle,
  Link,
  BarChart3,
  Cpu,
  GitFork,
  XCircle,
  Server,
  Scale,
  Timer,
  Hash,
  Briefcase,
  KeyRound,
  Mail,
  Phone,
};

export default Icons;
